import "./Welcome.css";

export function Welcome() {
  return (
    <>
    <div className="welcome-message">
      <div className="title-content">
        {/* <img src="static/images/LucaBotLogo.png" alt="luca-bot-logo" id="luca-bot-logo" /> */}
        <h1 className="luca-bot-title">LUCA Bot.</h1>
      </div>
        <div className="subtitle-content">
          <p className="subtitle">Your smart financial assistant from CEMEX</p>
          <p className="subtitle">Currently providing MTM information with continuous incorporation of LUCA indicators.</p>
        </div>
    </div>
    </>
  );
}